import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';
import {PartnerModel} from '@/models/partner.model';

export const featureKey = 'partners';

// @ts-ignore
if (store.state.partners) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class PartnersStoreModule extends EntityStateAdapter<PartnerModel> {

  get partners(): PartnerModel[] {
    return this._entities;
  }

  @Action({commit: 'insertMany', rawError: true})
  fetchAll(challengeId: number): Promise<PartnerModel[]> {
    return (new ChallengesApi())
      .findPartners(challengeId)
      .pipe(take(1))
      .toPromise()
  }
}
